import { render, staticRenderFns } from "./UserAreaModal.vue?vue&type=template&id=7e47abbc&scoped=true&"
import script from "./UserAreaModal.vue?vue&type=script&lang=js&"
export * from "./UserAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e47abbc",
  null
  
)

export default component.exports